import { MouseEvent } from 'react'

export const hasModifierKey = (e: MouseEvent | KeyboardEvent) => {
  if (/^mac|iphone|ipad/i.test(navigator.platform)) {
    return e.metaKey
  }
  return e.ctrlKey
}
